{
  "monthly_label": "Månadsvis",
  "yearly_label": "Årsvis",
  "yearly_savings": "(Spara {{amount}})",
  "no_offers": "Inga prenumerationsalternativ tillgängliga.",
  "purchase_options_unavailable": "Alternativ för betalplan är tillfälligt otillgängliga.",
  "try_again": "Försök igen",
  "loading": "Laddar...",
  "voucher_button": "Kupong? Klicka här.",
  "test_store_badge": "Testbutik - simulerade köp",
  "purchase_failed": "Ett fel uppstod under köpet.",
  "period_year": "år",
  "period_month": "månad",
  "no_active_subscription_title": "Ingen aktiv prenumeration",
  "no_active_subscription_message": "Prenumerera för att låsa upp alla övningar och funktioner.",
  "subscribe_cta": "Visa planer"
}
